/**
 * 控制文件加载的主文件
 */
require(['angular', 'app', 'domReady', 'auiConfig',
    // 常量
    'constant/common/huawei-error-zh.constant',
    // controller
    'controllers/MemberCenterController',
    'controllers/aplpromote/apl-promote-select.ctrl',//云文件夹推广选择
    'controllers/aplpromote/cloud-folder-promote-list.ctrl',//云文件夹推广
    'controllers/aplpromote/cloud-folder-promote-add.ctrl',//云文件夹推广添加页面
    'controllers/myreport/myreport-main.ctrl',
    'controllers/myreport/myreport-appmarket.ctrl',
    'controllers/myreport/myreport-account.ctrl',
    'controllers/myreport/myreport-payment.ctrl',
    'controllers/myreport/myreport-cloud-folder.ctrl',
    'controllers/myreport/myreport-app-promote.ctrl',
    'controllers/myreport/myreport-app-statistics.ctrl',
    'controllers/myreport/myreport-app-adbanalysis.ctrl',
    'controllers/myreport/myreport-theme.ctrl',
    'controllers/mymessage/mymessage',
    'controllers/myaccount/myaccount',
    'controllers/myaccount/balance/account-mainbalance.ctrl',
    'controllers/myaccount/balance/account-balance.ctrl',
    'controllers/myaccount/balance/order-detail.ctrl',
    'controllers/myaccount/balance/refund-detail.ctrl',
    'controllers/myaccount/balance/gift-balance-detail.ctrl',
    'controllers/myaccount/earnings/account-earnings.ctrl',//老收益
    'controllers/myaccount/new-earnings/account-new-earnings.ctrl',//新收益
    'controllers/myaccount/settlement/account-new-settlement.ctrl',//新收益和余额的结算单
    'controllers/myaccount/dispute/account-dispute.ctrl',//新收益和余额的争议单
    'controllers/myaccount/dispute/account-disputeDetail.ctrl',//新收益和余额的争议单
    'controllers/myaccount/bills/account-bills.ctrl',//帐号菜单
    'controllers/mysetting/mysetting',
    'controllers/mysetting/HandlerUserInfoController',
    'controllers/mysetting/mod-userinfoper.ctrl',
    'controllers/mysetting/mod-userinfocorp.ctrl',
    'controllers/mysetting/mod-bussiness.ctrl',
    'controllers/mysetting/mod-payservice.ctrl',
    'controllers/mysetting/mod-invoice.ctrl',
    'controllers/mysetting/namechange/name-change.ctrl',
    'controllers/mysetting/namechange/name-change-mod-bussiness.ctrl',
    'controllers/mysetting/namechange/name-change-mod-userinfocorp.ctrl',
    'controllers/mysetting/namechange/name-change-mod-userinfoper.ctrl',
    'controllers/mysetting/namechange/name-change-submit-success.ctrl',
    'controllers/mysetting/corpattation/valid-userinfocorp.ctrl',
    'controllers/mysetting/corpattation/valid-result.ctrl',
    'controllers/common/iframe-help.ctrl',
    'controllers/common/page-embed.ctrl',//外部页面嵌入
    'controllers/myservices/myservice-list.ctrl',
    'controllers/myservices/rollout.ctrl',
    'controllers/myservices/sel-pkg.ctrl',
    'controllers/myservices/common/submit-success.ctrl',
    'controllers/myservices/pay/pay-detail.ctrl',
    'controllers/myservices/huaweiid/huaweiid-detail.ctrl',
    'controllers/myservices/game/game-detail.ctrl',//游戏详情
    'controllers/servicecards/servicecards.ctrl',
    'controllers/reportcards/reportcards.ctrl',
    'controllers/opencard/opencard.iframe.ctrl',
    'controllers/mysetting/teamaccount/teamaccount-list.ctrl',
    'controllers/mysetting/teamaccount/add.member.account.ctrl',
    'controllers/mysetting/teamaccount/add.member.account.account.ctrl',
    'controllers/mysetting/teamaccount/add.member.account.role.permission.ctrl',
    'controllers/mysetting/teamaccount/add.member.account.confirm.ctrl',
    'controllers/mysetting/teamaccount/member.account.detail.ctrl',
    'controllers/mysetting/teamaccount/teamaccount-list.ctrl',
    'controllers/mysetting/teamaccount/add.member.account.ctrl',
    'controllers/mysetting/teamaccount/add.member.account.account.ctrl',
    'controllers/mysetting/teamaccount/add.member.account.role.permission.ctrl',
    'controllers/mysetting/teamaccount/add.member.account.confirm.ctrl',
    'controllers/mysetting/teamaccount/member.account.detail.ctrl',
    'controllers/memberservices/commodityMain.ctrl',
    'controllers/memberservices/commodityList',
    'controllers/memberservices/myCommodityList',
    'controllers/questionnaire/questionnaire.ctrl',
    'controllers/cloudacademy/mod-cloud-academyInfo.ctrl',
    'controllers/incentive/myIncentive.ctrl',
    'controllers/incentive/myIncentive-detail.ctrl',
    'controllers/incentive/myIncentive-apply.ctrl',
    'vendors/bi/hajssdk',
    'services/common/ajax/AppPromote',
    'services/common/ajax/openApp',
    'services/common/ajax/openFeedback',
    'services/common/ajax/inAppNew',
    'services/common/ajax/openOther',
    'services/common/ajax/openUp',
    'services/common/ajax/openGW',
    'services/common/ajax/hispaceStore',
    'services/common/ajax/balanceApp',
    'services/common/ajax/huaweiTrade',
    'services/common/ajax/hiGame',
    'services/common/ajax/OpenTrade',
    'services/common/ajax/hiCloudFolder',
    'services/common/userInfo',
    'services/common/dialog-questionnaire-tip-service',
    'services/common/langService',
    'services/common/common-utils',
    'services/appmng/get-app-parameter.service',
    'services/mysetting/region.service',
    'services/mysetting/mod.userinfo.service',
    'services/mysetting/mod.bussiness.service',
    'services/mysetting/bank.select.service',
    'services/mysetting/invoice.service',
    'services/mysetting/add.contactor.service',
    'services/mysetting/form.validate.service',
    'services/mysetting/tenants.service',
    'services/appmng/app-claims.service', // 应用认领服务
    'services/common/userAuth',
    'services/myreport/myreport-app-statistics-common.services',//应用分析报表前三个
    'services/myreport/myreport-all.service',//报表公共方法
    'services/appmng/operanteSha.service',
    'services/bi/bi.analytic.service',
    'services/myservices/myservice-list.service',
    'services/myservices/myservice-package.service',
    'services/myservices/pay.service',
    'services/myservices/myservice-add-service.service',
    'services/myservices/game.service',//游戏 service
    'services/myservices/huaweiid.service',
    'services/myservices/add-product-alliance.service',
    'services/mymessage/mymessage.service',
    'services/common/handleMainPageDia-service',
    'services/common/exportExcel',
    'services/memberservices/paid-member.service',
    'services/cloudacademy/cloud-academy.service',
    'services/myIncentive/myIncentive.service',
    'services/mysetting/petals.service',
    'services/common/ajax/PartnerMarketSOService',
    'directives/common/dayschedule/day.schedule.directives',
    'directives/common/footer/footer.directives',
    'directives/myreport/eCharts.directives',
    'directives/myreport/public-filter.directives',
    'directives/myreport/app-task-checkbox.directives',
    'directives/myservices/serviceMark/serviceMark.directives',//服务卡片评分指令
    'directives/myservices/serviceMark/serviceMarkPage.directives',//服务卡片评分指令
    'directives/common/verify-code/verify-code.directive',
    'directives/common/verify-code/verify-email-code.directive',
    'directives/common/stepNavigator/stepNavigator.directive',
    'directives/myservices/fingerPrint/fingerPrint.directives',
    'directives/myservices/packageName/packageName.directives',
    'directives/myservices/callbackUrl/callbackUrl.directives',
    'directives/myservices/callbackUrl/callbackUrlForAccount.directives',
    'directives/mysetting/beneficiaries.directives',
    'directives/mysetting/identityInfo.directives',
    'directives/mysetting/operationInfo.directives',
    'directives/myservices/bundleId/bundleId.directives',
    'directives/common/bi-analytic/bi-analytic.directive',
    'directives/common/training/training.directives',
    'directives/myservices/accessMode/accessMode.directives',
    'directives/myservices/secureUrl/secureUrl.directives',
    'directives/myservices/appIcon/appIcon.directives',
    'directives/checkBrower/check-brower.directive',
    'directives/tipMsg/tip-msg.directive',
    'directives/common/dynamic-grid/dynamicGrid.directives',
    'directives/common/mul-select/mulSelect.directives',
    'filters/appmng/appmange-appsrfs.filter',
    'filters/appmng/csv-injection.filter',
    'filters/appmng/contract-type.filter',
    'filters/appmng/reward-type.filter',
    'services/serviceresources/serviceresource.service',
    //consoleApi 引入
    'controllers/consoleApi/credentialsMain.ctrl',
    'controllers/consoleApi/serviceAccountKeysAdd.ctrl',
    'controllers/consoleApi/serviceAccount.ctrl',
    'controllers/consoleApi/myApi.ctrl',
    'controllers/consoleApi/apiList.ctrl',
    'controllers/consoleApi/myApi.detail.ctrl',
    'controllers/consoleApi/apiList.detail.ctrl',
    'controllers/consoleApi/apiKey.ctrl',
    'controllers/consoleApi/oauth.ctrl',
    'controllers/consoleApi/oauthClient.apiList.ctrl',
    'controllers/consoleApi/myScope.ctrl',
    'controllers/consoleApi/oauthClient.apiDetail.ctrl',
    'controllers/consoleApi/myDashboard.ctrl',
    'controllers/consoleApi/privacy.contactorsList.ctrl',
    'services/consoleApi/project.manage.service',
    'directives/consoleApi/project.head',
    // 耀星流量券
    'controllers/myaccount/balance/account-flow-transfer.ctrl',
    'controllers/myaccount/balance/flow-detail.ctrl',
    'controllers/mysetting/iframe-help-team.ctrl',

], function (angular, app, domReady, auiConfig) {

    // AllianceUI初始化
    app.config(["$auiInitProvider", auiConfig]);

    app.config(['$stateProvider', '$urlRouterProvider', router]).run(['UserInfo', '$timeout', 'ngDialog', init]);

    app.config(['ngDialogProvider', function (ngDialogProvider) {
        ngDialogProvider.setDefaults({
            className: 'ngdialog-theme-default',
            showClose: true,
            closeByNavigation: false,
            plain: false,
            closeByEscape: false,
            closeByDocument: true
        })
    }]);
    //处理控制台报错的问题 当只写reject而没有写catch的时候报错的问题，兼容angular1.7
    app.config(['$qProvider', function ($qProvider) {
        $qProvider.errorOnUnhandledRejections(sysParamCfg.switchConf.isUnhandledRejections);
    }]);
    app.config(['$provide', function ($provide) {
        $provide.decorator("$exceptionHandler", ['$delegate', function ($delegate) {
            return function (exception, cause) {
                var msg = "message " + exception.message + " stack " + exception.stack + " cause " + cause;
                AUI.errorCollect.globalJSError({
                    "url": "NA",
                    "line": "NA",
                    "col": "NA",
                    "msg": msg,
                    "jsErrorType": "angularjsError"
                });
                $delegate(exception);

            };
        }]);
    }]);
    // 添加对应的 Interceptors
    app.config(['$httpProvider', '$locationProvider', function ($httpProvider, $locationProvider) {
        $httpProvider.interceptors.push(['$q', AUI.errorCollect.globalHttpInterceptor]);
        $locationProvider.hashPrefix('');
    }]);

    // 引入开发mock模式，mock模式会注入假数据，方便大家本地调试
    if (sysUrlCfg.devMode) {
        window.globalMockData = [];
        require(['mockconfig'], function () {
            domReady(function () {
                angular.bootstrap(document, ['MemberCenter'], {strictDi: true});
            });
        })
    } else {
        domReady(function () {
            angular.bootstrap(document, ['MemberCenter'], {strictDi: true});
        });
    }

});

function router($stateProvider, $urlRouterProvider) {
    //appMarketSelProd
    if (!AUI.HDGWCall.getUserInfoValue('teamid')) {
        $urlRouterProvider.otherwise('serviceCards/');
    } else {
        $urlRouterProvider.otherwise('mysetting/');
    }

    $stateProvider.state('home', {
        redirectTo: 'serviceCards',
        params: {dirId: ''}
    }).state('serviceCards', {
        url: '/serviceCards/*dirId',
        templateUrl: 'pages/servicecards/serviceCards.html',
        controller: 'ServiceCardsController',
        resolve: preload('UserInfo', '服务卡片列表', 'DPRM5001')
    }).state('reportCards', {
        url: '/reportCards/*dirId',
        templateUrl: 'pages/reportcards/reportCards.html',
        controller: 'ReportCardsController',
        resolve: preload('UserInfo', '我的报表卡片列表', 'DPRM5002')
    }).state('openCard', {
        url: '/openCard/:dirId/:cardId',
        templateUrl: 'pages/opencard/openCardIframe.html',
        controller: 'OpenCardIframeController'
    }).state('openCardParam', {
        url: '/openCard/:dirId/:cardId/{param:[^@#//]+}',
        templateUrl: 'pages/opencard/openCardIframe.html',
        controller: 'OpenCardIframeController'
    }).state('incentive', {
        url: '/incentive',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
    }).state('accountReport', {
        url: '/accountReport',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
    }).state('consumptionRecord', {
        url: '/consumptionRecord',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
    }).state('myServiceList', {
        url: '/myServiceList/{serviceItem:[0-9]{1,4}}',
        templateUrl: 'pages/myservices/myservice.list.html',
        controller: 'MyServiceList',
        resolve: preload('UserInfo', '')
    }).state('myServiceListPay', {
        url: '/myServiceListPay',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
    }).state('myServiceListId', {
        url: '/myServiceListId',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
    }).state('harmonyOsCard', {
        url: '/harmonyOsCard',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '')
    }).state('myServiceList.payDetail', {
        url: '/payDetail/{prodID:[0-9]{1,30}}',
        templateUrl: 'pages/myservices/pay/pay.detail.html',
        controller: 'payDetailCtrl',
        resolve: preload('UserInfo')
    }).state('myServiceList.huaweiIdDetail', {
        url: '/huaweiIdDetail/{prodID:[0-9]{1,30}}',
        templateUrl: 'pages/myservices/huaweiId/huaweiid.detail.html',
        controller: 'huaweiidDetailCtrl',
        resolve: preload('UserInfo')
    }).state('myServiceList.gameDetail', {
        url: '/gameDetail/{prodID:[0-9]{1,30}}/{srvSerialNo:[0-9]+}',
        templateUrl: 'pages/myservices/game/game.detail.html',
        controller: 'GameDetailCtrl',
        resolve: preload('UserInfo')
    }).state('rollout', {
        url: '/rollout',
        params: {serviceItem: null, product: null},
        templateUrl: 'pages/myservices/rollout.html',
        controller: 'rolloutCtrl',
        resolve: preload('UserInfo')
    }).state('rollout.selPkg', {
        url: '/selPkg/:serviceItem',
        params: {serviceItem: null, product: null},
        templateUrl: 'pages/myservices/common/selPkg.html',
        controller: 'selPkgCtrl',
        resolve: preload('UserInfo')
    }).state('rollout.submitSuccess', {
        url: '/submitSuccess',
        params: {serviceItem: null},
        templateUrl: 'pages/myservices/common/submit.success.html',
        controller: 'submitSuccess',
        resolve: preload('UserInfo')
    }).state('rollout.submitSuccess-intelligent', {
        url: '/submitSuccess-intelligent',
        params: {serviceItem: null},
        templateUrl: 'pages/myservices/common/submit.success.html',
        controller: 'submitSuccess',
        resolve: preload('UserInfo')
    }).state('aplPromoteSelect', {
        url: '/aplPromoteSelect',
        templateUrl: 'pages/aplpromote/apl.promote.select.html',
        controller: 'aplPromoteSelect'
    }).state('aplPromoteCFList', {
        url: '/cFPromoteList',
        templateUrl: 'pages/aplpromote/cloud.folder.promote.list.html',
        controller: 'cFPromoteListCtrl'
    }).state('aplPromoteCFAdd', {
        url: '/cFPromoteAdd/{taskId:[0-9]{1,30}}/{serviceItem:[0-9]{1,2}}',
        templateUrl: 'pages/aplpromote/cloud.folder.promote.add.html',
        controller: 'cFPromoteAddCtrl'
    }).state('myReport', {
        url: '/myReport',
        templateUrl: 'pages/myreport/myreport.html',
        controller: 'myReport'
    }).state('myReport.appMarket', {
        url: '/appMarket',
        templateUrl: 'pages/myreport/myreport.appMarket.html',
        controller: 'appMarketReport'
    }).state('myReport.push', {
        url: '/push',
        templateUrl: 'pages/myreport/myreport.push.html',
        controller: 'pushReport'
    }).state('myReport.payment', {
        url: '/payment',
        params: {startDate: null, endDate: null},
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
    }).state('myReport.account', {
        url: '/account',
        templateUrl: 'pages/myreport/myreport.account.html',
        controller: 'AccountReport'
    }).state('myReport.cFolder', {
        url: '/cFolder',
        templateUrl: 'pages/myreport/myreport.cfolder.html',
        controller: 'CFolderReport'
    }).state('myReport.appPromote', {
        url: '/app-promote',
        templateUrl: 'pages/myreport/myreport.app.promote.html',
        controller: 'AppPromoteReport'
    }).state('myReport.appStatistics', {
        url: '/app-statistics',
        templateUrl: 'pages/myreport/myreport.app.statistics.html',
        controller: 'AppStatisticsReport'
    }).state('myReport.adBAnalysis', {//广告变现报表
        url: '/app-adBAnalysis',
        templateUrl: 'pages/myreport/myreport.adbanalysis.html',
        controller: 'AdBAnalysisReport'
    }).state('myReport.theme', {//主题报表
        url: '/app-theme',
        templateUrl: 'pages/myreport/myreport.theme.html',
        controller: 'themeReport'
    }).state('MyMessage', {
        url: '/mymessage',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('', '我的消息', 'DPRM5006')
    }).state('MyAccount', {
        url: '/myaccount',
        templateUrl: 'pages/myaccount/myaccount.html',
        controller: 'MyAccount'
    }).state('MyAccount.mainbalance.bill', {
        url: '/mainbalance-bill/{signParty}',
        templateUrl: 'pages/myaccount/balance/account.balance.html',
        controller: 'AccountBalanceCtrl',
        resolve: preload('UserInfo', '我的账户 - 账单', 'DPRM5007')
    }).state('MyAccount.mainbalance', {
        url: '/mainbalance/{signParty}',
        templateUrl: 'pages/myaccount/balance/account.main.balance.html',
        controller: 'AccountMainBalanceCtrl',
        resolve: preload('UserInfo', '我的账户 - 余额', 'DPRM5008')
    }).state('balance', {//切换余额菜单的路由菜单路由
        url: '/balance/{signParty}',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo')
    }).state('MyAccount.earnings', {//老收益菜单路由
        url: '/earnings',
        templateUrl: 'pages/myaccount/earnings/account.earnings.html',
        controller: 'AccountEarningsCtrl',
        resolve: preload('UserInfo', '')
    }).state('MyAccount.newEarnings', {//新收益菜单路由
        url: '/new-earnings',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '我的账户 - 收益', 'DPRM5009')
    }).state('MyAccount.newEarnings.settlement', {
        url: '/new-earnings-settlement',
        templateUrl: 'pages/myaccount/settlement/account.new.settlement.html',
        controller: 'AccountNewSettlementCtrl',
        resolve: preload('', '我的账户 - 收益结算单', 'DPRM5010')
    }).state('MyAccount.newEarnings.dispute', {
        url: '/new-earnings-dispute',
        templateUrl: 'pages/myaccount/dispute/account.dispute.html',
        controller: 'AccountDisputeCtrl',
        resolve: preload('', '我的账户 - 收益争议处理', 'DPRM5011')
    }).state('MyAccount.disputeEarningsDetail', {
        url: '/dispute-earning-detail{dispute}',
        templateUrl: 'pages/myaccount/dispute/account.dispute.detail.html',
        controller: 'AccountDisputeDetailCtrl',
        resolve: preload('UserInfo', '我的账户 - 单条争议单详情', 'DPRM5012')
    }).state('MyAccount.bills', {//账单菜单路由
        url: '/bills',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '账单', 'DPRM5007')
    }).state('MyAccount.bills.settlement', {
        url: '/bills-settlement',
        templateUrl: 'pages/myaccount/settlement/account.new.settlement.html',
        controller: 'AccountNewSettlementCtrl',
        resolve: preload('', '我的账户 - 账单结算单', 'DPRM5013')
    }).state('MyAccount.bills.settlement2', {//给华为云使用路由，支持
        url: '/bills-settlement/:billno/:startTime/:endTime',
        templateUrl: 'pages/myaccount/settlement/account.new.settlement.html',
        controller: 'AccountNewSettlementCtrl',
        resolve: preload('', '我的账户 - 账单结算单', 'DPRM5013')
    }).state('MyAccount.bills.dispute', {
        url: '/bills-dispute',
        templateUrl: 'pages/myaccount/dispute/account.dispute.html',
        controller: 'AccountDisputeCtrl',
        resolve: preload('', '我的账户 - 账单争议单', 'DPRM5014')
    }).state('MyAccount.disputeBillsDetail', {
        url: '/dispute-bill-detail{dispute}',
        templateUrl: 'pages/myaccount/dispute/account.dispute.detail.html',
        controller: 'AccountDisputeDetailCtrl',
        resolve: preload('UserInfo', '我的账户 - 单条争议单详情', 'DPRM5012')
    }).state('MyAccount.orderDetail', {
        url: '/order-detail/orderId={orderId}&signParty={signParty}',
        templateUrl: 'pages/myaccount/balance/order.detail.html',
        controller: 'OrderDetailCtrl',
        resolve: preload('', '我的账户 - 订单详情', 'DPRM5015')
    }).state('MyAccount.refundDetail', {
        url: '/refund-detail/orderId={orderId}&signParty={signParty}',
        params: {orderMoney: null},
        templateUrl: 'pages/myaccount/balance/refund.detail.html',
        controller: 'RefundDetailCtrl',
        resolve: preload('', '我的账户 - 退款详情', 'DPRM5119')
    }).state('mysetting', {
        url: '/mysetting',
        templateUrl: 'pages/mysetting/mysetting.html',
        controller: 'MySetting',
        resolve: preload('UserInfo', '')
    }).state('mysetting.userInfo', {
        url: '/',
        controller: 'HandlerUserInfoController',
        resolve: preload('UserInfo', '')
    }).state('mysetting.modUserInfoPer', {
        url: '/modUserInfoPer',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('', '设置 - 个人用户信息变更', 'DPRM5016')
    }).state('mysetting.modUserInfoCorp', {
        url: '/modUserInfoCorp',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('', '设置 - 企业用户信息变更', "DPRM5017"),
        params: {quetionnareLable: null}
    }).state('mysetting.memberDetail', {
        url: '/memberDetail',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 成员帐号信息查看', "DPRM5018")
    }).state('mysetting.accountGroup', {
        url: '/accountGroup',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '')
    }).state('mysetting.modBussnessInfo', {
        url: '/modBussnessInfo',
        params: {settlement: null},
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 商户信息变更', "DPRM5019")
    }).state('mysetting.payService', {
        url: '/modPayService',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 查看付费服务信息', "DPRM5020")
    }).state('mysetting.validCorpattion', {
        url: '/validCorpattion',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 打款验证', "DPRM5021")
    }).state('mysetting.validCorpResult', {
        url: '/validCorpResult/corpResult={corpResult}',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 打款验证结果', "DPRM5022")
    }).state('mysetting.payService.modInvoice', {
        url: '/modInvoice',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 发票信息变更', "DPRM5023")
    }).state('mysetting.teamAccountInfoList', {
        url: '/teamAccountInfoList',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 团队帐号列表查询', "DPRM5024")
    }).state('mysetting.addMemberAccount', {
        url: '/addMemberAccount',
        params: {teamMemberInfo: null, memberResInfo: null},
        templateUrl: 'pages/mysetting/teamaccount/add.member.account.html',
        controller: 'AddMemberAccountCtrl',
        resolve: preload('UserInfo', '设置 - 团队帐号帐号信息', "DPRM5025")
    }).state('mysetting.addMemberAccount.account', {
        url: '/account',
        params: {teamMemberInfo: null, memberResInfo: null},
        templateUrl: 'pages/mysetting/teamaccount/account.add.html',
        controller: 'AddMemberAccountAccountCtrl',
        resolve: preload('UserInfo', '设置 - 团队帐号成员信息', "DPRM5026")
    }).state('mysetting.addMemberAccount.rolePermission', {
        url: '/rolePermission',
        params: {teamMemberInfo: null, memberResInfo: null},
        templateUrl: 'pages/mysetting/teamaccount/role.permission.html',
        controller: 'AddMemberAccountRolePermissionCtrl',
        resolve: preload('UserInfo', '设置 - 团队帐号成员角色权限信息', "DPRM5027")
    }).state('mysetting.addMemberAccount.confirm', {
        url: '/confirm',
        params: {teamMemberInfo: null, memberResInfo: null},
        templateUrl: 'pages/mysetting/teamaccount/confirm.html',
        controller: 'AddMemberAccountConfirmCtrl',
        resolve: preload('UserInfo', '设置 - 团队帐号确认信息', "DPRM5028")
    }).state('mysetting.memberAccountDetail', {
        url: '/memberAccountDetail/{fakeMemberID:[a-zA-Z0-9]{1,32}}',
        templateUrl: 'pages/mysetting/teamaccount/member.account.detail.html',
        controller: 'MemberAccountDetailCtrl',
        resolve: preload('UserInfo', '设置 - 团队帐号详情', "DPRM5029")
    }).state('nameChangeCorp', {//更名需求 start  企业更名
        url: '/nameChangeCorp',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 企业更名', "DPRM5030")
    }).state('nameChangeCorp.userInfoCorp', { //企业更名基础信息
        url: '/userInfoCorp',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 企业更名基础信息', "DPRM5031")
    }).state('nameChangeCorp.modBussnessInfo', {//企业更名银行信息
        url: '/modBussnessInfoCorp',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 企业更名商户信息', "DPRM5032")
    }).state('nameChangeCorp.submitSuccess', {//企业更名成功后
        url: '/submitSuccessCorp',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 开发者企业更名提交成功', 'DPRM5033')
    }).state('nameChangePer', {//个人更名
        url: '/nameChangePer',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 个人更名', "DPRM5034")
    }).state('nameChangePer.userInfoPer', {//个人更名基础信息
        url: '/userInfoPer',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 个人更名基础信息', "DPRM5035")
    }).state('nameChangePer.modBussnessInfo', {//个人更名银行信息
        url: '/modBussnessInfoPer',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 个人更名商户信息', "DPRM5036")
    }).state('nameChangePer.submitSuccess', {//个人更名成功后
        url: '/submitSuccessPer',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '设置 - 开发者个人更名提交成功', 'DPRM5037')//更名需求end
    }).state('iframe-help', {//esdk客服工作流
        url: '/iframe-help',
        templateUrl: 'pages/common/iframe.help.html',
        controller: 'IframeHelp'
    }).state('embedPMS', {//支付pms,改用联运的iframe
        url: '/embed/{prodID:[0-9]{1,30}}',
        params: {paramInf: {}},
        templateUrl: 'pages/unionopscenter/union.ops.iframe.html',
        controller: 'embedPageControlller',
        resolve: preload('UserInfo')
    }).state('memberservices', {
        url: '/paidMain',
        templateUrl: 'pages/memberservices/commodityMain.html',
        controller: 'CommodityMain'
    }).state('memberservices.commodityList', {
        url: '/commodityList',
        templateUrl: 'pages/memberservices/commodityList.html',
        controller: 'CommodityList'
    }).state('memberservices.myCommodityList', {
        url: '/myCommodityList',
        templateUrl: 'pages/memberservices/myCommodityList.html',
        controller: 'MyCommodityList'
    }).state('questionnaire', {
        url: '/questionnaire/{isUpdate:[0-9]{0,1}}',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '')
    }).state('modCloudCademyinfo', {
        url: '/modCloudCademyinfo',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '')
    }).state('myApi', {//Console APIS
        url: '/myApi/{projectKey:[0-9a-z-]{0,64}}',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '')
    }).state('myApiDetail', {//Console APIS
        url: '/myApi/{projectKey:[0-9a-z-]{0,64}}/detail/{apiID:[0-9a-z-]{0,32}}',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', 'APIConsole - API详情页面', 'DPRM5061')
    }).state('apiList', {
        url: '/apiList/{projectKey:[0-9a-z-]{0,64}}',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '')
    }).state('apiListDetail', {
        url: '/apiList/{projectKey:[0-9a-z-]{0,64}}/detail/{apiID:[0-9a-z-]{0,32}}',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', 'APIConsole - API详情页面', 'DPRM5061')
    }).state('credentials', {
        url: '/credentials/projectKey={projectKey}',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '')
    }).state('addServiceAcccountKeys', {
        url: '/addServiceAcccountKeys/projectKey={projectKey}&clientID={clientID}',
        templateUrl: 'pages/consoleApi/serviceAccount/serviceAccountKeys.add.html',
        controller: 'ServiceAccountKeysAdd',
        resolve: preload('', 'APIConsole - 服务帐号配置页面', 'DPRM5066')
    }).state('serviceAccount', {
        url: '/serviceAccount/={projectKey}',
        templateUrl: 'pages/consoleApi/serviceAccount/serviceAccountMain.html',
        controller: 'ServiceAccount',
        resolve: preload('UserInfo', 'APIConsole - 服务帐号列表页面', 'DPRM5065')
    }).state('apiKey', {
        url: '/apiKey/{projectKey:[0-9a-z-]{0,64}}/{projectID:[0-9a-z-]{0,64}}/{clientID:[0-9]{0,20}}',
        templateUrl: 'pages/consoleApi/apiKey/apiKey.html',
        controller: 'apiKeyCtrl',
        resolve: preload('UserInfo', 'APIConsole - API密钥设置页面', 'DPRM5063')
    }).state('oauth', {
        url: '/oauth/{projectKey:[0-9a-z-]{0,64}}/{projectID:[0-9a-z-]{0,64}}/{clientID:[0-9]{0,20}}',
        templateUrl: 'pages/consoleApi/oauth/oauth.html',
        controller: 'oauthCtrl',
        resolve: preload('UserInfo', 'APIConsole - OAuth 2.0 客户端 ID 配置页面', 'DPRM5064')
    }).state('oauthClient', {
        url: '/oauthClient/{type:[0-9]{0,1}}/{projectKey:[0-9a-z-]{0,64}}/{projectID:[0-9a-z-]{0,64}}/{clientID:[0-9]{0,20}}',
        templateUrl: 'pages/consoleApi/oauth/oauth.html',
        controller: 'oauthCtrl',
        resolve: preload('UserInfo', 'APIConsole - 应用级客户端配置页面', 'DPRM5069')
    }).state('oauthClientApiList', {
        url: '/oauthClientApiList/{projectID:[0-9a-z-]{0,64}}/{clientID:[0-9]{0,20}}',
        templateUrl: 'pages/consoleApi/oauthClient/oauthClientApiList.html',
        controller: 'OauthClientApiList',
        resolve: preload('UserInfo', 'APIConsole - 应用级客户端API列表页面', 'DPRM5068')
    }).state('oauthClientApiDetail', {
        url: '/oauthClientApiDetail/{projectID:[0-9a-z-]{0,64}}/{clientID:[0-9]{0,20}}/{apiID:[0-9]{0,20}}',
        templateUrl: 'pages/consoleApi/oauthClient/oauthClientApiDetail.html',
        controller: 'OauthClientApiDetail',
        resolve: preload('UserInfo')
    }).state('oauthClientApiView', {
        url: '/oauthClientApiView/{projectID:[0-9a-z-]{0,64}}/{clientID:[0-9]{0,20}}/{apiID:[0-9]{0,20}}',
        templateUrl: 'pages/consoleApi/oauthClient/oauthClientApiView.html',
        controller: 'OauthClientApiDetail',
        resolve: preload('UserInfo', 'APIConsole - 查看应用级客户端API页面', 'DPRM5071')
    }).state('myProject', {
        url: '/myProject',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', 'APIConsole - 我的项目页面', 'DPRM5058')
    }).state('myDashboard', {
        url: '/myDashboard/{projectKey:[0-9a-z-]{0,64}}',
        templateUrl: 'pages/consoleApi/my.dashboard.html',
        controller: 'myDashboardCtrl',
        resolve: preload('UserInfo', 'APIConsole - 查看Dashboard页面', 'DPRM5072')
    }).state('myIncentive', {
        url: '/myIncentive',
        templateUrl: 'pages/incentive/myIncentive.list.html',
        controller: 'myIncentiveCtrl',
        resolve: preload('UserInfo', '')
    }).state('myIncentiveDetail', {
        url: '/myIncentive/detail/serialNum={serialNum}&appName={appName}',
        templateUrl: 'pages/incentive/myIncentive.detail.html',
        controller: 'incentiveDetailCtrl',
        resolve: preload('UserInfo')
    }).state('myIncentiveApply', {
        url: '/myIncentive/apply',
        templateUrl: 'pages/incentive/myIncentive.apply.html',
        controller: 'incentiveApplyCtrl',
        resolve: preload('UserInfo', '')
    }).state('privacyContactor', {
        url: '/privacyContactorList',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', 'APIConsole - 隐私联系信息', 'DPRM5073')
    }).state('MyAccount.flowTransfer', {
        url: '/flowTransfer/orderId={orderId}',
        templateUrl: 'pages/myaccount/balance/balance.flow.transfer.html',
        controller: 'FlowTransferCtrl',
        resolve: preload('UserInfo', '我的账户 - 耀星流量券', '')
    }).state('MyAccount.flowDetail', {
        url: '/flowDetail/orderId={orderId}',
        templateUrl: 'pages/myaccount/balance/flow.detail.html',
        controller: 'FlowDetailCtrl',
        resolve: preload('UserInfo', '转移详情', '')
    }).state('scopeManage', {
        url: '/scopeManage',
        templateUrl: 'pages/common/iframe.html',
        controller: 'IframeHelpTeam',
        resolve: preload('UserInfo', '')
    });
}

function init(UserInfo, $timeout) {
    AUI.HDGWCall.checkLogin(function () {
        asyncJsHajssdk(UserInfo);
    });
}

function preload(service, titleStr, tagType, serviceItem) {
    var serviceName = service;
    var name = service + 'Preload';
    var obj = {};
    obj[name] = [service || 'UserInfo', 'biAnalyticService', function (service, biAnalyticService) {
        if (titleStr) {
            biAnalyticService.trackPageView(titleStr, tagType, serviceItem);
        }
        return serviceName && service.promise();
    }];
    return obj;
}


function asyncJsHajssdk(UserInfo) {
    UserInfo.initHianalytics();
}



;
define("mcindex", function(){});

